// Vuex records module main file
import actions from './actions';
import mutations from './mutations';

const INITIAL_STATE = {
  list: {
    page: 1,
    records: [],
    total: 0,
  },
  statusAndRecordDictionary: {
    record_dictionary: [],
    status_dictionary: []
  },
  surveysList: [],
  currentCallDetails: [],
  surveyInputTypesList: [],
  currentCallSurvey: [],
  surveyQuestions: [],
  surveyResultslist: {
    records: [],
    total: 0,
  },
  surveyAnswers: [],
};

const getters = {
  list: state => state.list,
  statusAndRecordDictionary: state => state.statusAndRecordDictionary,
  currentCallDetails: state => state.currentCallDetails,
  surveyInputTypesList: state => state.surveyInputTypesList,
  surveysList: state => state.surveysList,
  currentCallSurvey: state => state.currentCallSurvey,
  surveyQuestions: state => state.surveyQuestions,
  surveyResultslist: state => state.surveyResultslist,
  surveyAnswers: state => state.surveyAnswers
};

// VUEX MODULE /////////////////////////////////////////////////////////////////
const Module = {
  namespaced: true,
  state: INITIAL_STATE,
  mutations,
  actions,
  getters,
};

export default Module;
